import { render, staticRenderFns } from "./TeacherWorkList.vue?vue&type=template&id=149b6ac5&scoped=true"
import script from "./TeacherWorkList.vue?vue&type=script&lang=js"
export * from "./TeacherWorkList.vue?vue&type=script&lang=js"
import style0 from "./TeacherWorkList.vue?vue&type=style&index=0&id=149b6ac5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149b6ac5",
  null
  
)

export default component.exports